
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const LovableWidgetManager = () => {
  const location = useLocation();

  // Function to reinitialize the Lovable widget
  const reinitializeLovableWidget = () => {
    console.log('🔄 Reinitializing Lovable widget for route:', location.pathname);
    
    try {
      // Method 1: Try the lovable global object if it exists
      if (window.lovable?.reinit) {
        console.log('📱 Using window.lovable.reinit()');
        window.lovable.reinit();
      } else if (window.lovable?.scanForElements) {
        console.log('📱 Using window.lovable.scanForElements()');
        window.lovable.scanForElements();
      } else if (window.lovable?.init) {
        console.log('📱 Using window.lovable.init()');
        window.lovable.init();
      } else {
        // Method 2: Try to trigger a manual DOM scan by dispatching events
        console.log('📱 Triggering manual DOM scan via events');
        
        // Dispatch a custom event that the Lovable script might listen for
        const event = new CustomEvent('lovable:rescan', {
          detail: { route: location.pathname }
        });
        window.dispatchEvent(event);
        
        // Also try a DOMContentLoaded event which many widgets listen for
        const domEvent = new Event('DOMContentLoaded');
        document.dispatchEvent(domEvent);
        
        // Force a mutation observer trigger by making a small DOM change
        const tempElement = document.createElement('div');
        tempElement.style.display = 'none';
        tempElement.setAttribute('data-lovable-trigger', 'true');
        document.body.appendChild(tempElement);
        
        // Remove it after a short delay
        setTimeout(() => {
          if (tempElement.parentNode) {
            tempElement.parentNode.removeChild(tempElement);
          }
        }, 100);
      }
      
      console.log('✅ Lovable widget reinitialization completed');
    } catch (error) {
      console.warn('⚠️ Error reinitializing Lovable widget:', error);
    }
  };

  // Effect to handle route changes
  useEffect(() => {
    console.log('🚀 Route changed to:', location.pathname);
    
    // Small delay to ensure the new route's DOM is fully rendered
    const timeoutId = setTimeout(() => {
      reinitializeLovableWidget();
    }, 150);

    return () => clearTimeout(timeoutId);
  }, [location.pathname]);

  // Effect to handle initial load
  useEffect(() => {
    console.log('🔧 LovableWidgetManager mounted, checking widget status...');
    
    // Check if the widget is available on initial load
    const checkWidget = () => {
      console.log('Widget availability check:', {
        lovableExists: !!window.lovable,
        hasInit: !!window.lovable?.init,
        hasReinit: !!window.lovable?.reinit,
        hasScanForElements: !!window.lovable?.scanForElements
      });
    };
    
    // Check immediately
    checkWidget();
    
    // Also check after the script has had time to load
    setTimeout(checkWidget, 1000);
  }, []);

  return null; // This component doesn't render anything
};

export default LovableWidgetManager;
